import styled from 'styled-components'

import { Color } from '../../theme/color'

interface ToggleProps {
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  onToggle?: () => void
}

export function Toggle({ checked: _checked, defaultChecked, disabled, onToggle }: ToggleProps) {
  const handleChecked = () => {
    if (disabled) return
    onToggle?.()
  }

  return (
    <Container checked={defaultChecked ?? _checked} disabled={disabled} onClick={handleChecked}>
      <Inner />
      <Handler />
    </Container>
  )
}

export type { ToggleProps }

const Inner = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 13px;
  border-radius: 50vh;
  transform: translateY(-50%);
`

const Handler = styled.div`
  position: relative;
  z-index: 1;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.29);
`

const Container = styled.div<Pick<ToggleProps, 'checked' | 'disabled'>>`
  display: flex;
  align-items: center;
  position: relative;
  width: 40px;
  ${({ disabled }) => (disabled ? '' : 'cursor: pointer;')}
  > * {
    transition: 0.3s;
  }
  > ${Inner} {
    background-color: ${({ checked, disabled }) =>
      disabled ? Color.gray_2 : checked ? Color.primary_2 : Color.gray_4};
  }
  > ${Handler} {
    left: ${({ checked }) => (checked ? 'calc(100% - 20px)' : '0')};
    background-color: ${({ checked, disabled }) =>
      disabled ? Color.gray_5 : checked ? Color.primary_5 : Color.gray_2};
  }
`
